import { Box, Stack, Typography } from '@mui/material';
import type { ReactNode } from 'react';

type HomeSectionProps = {
  id: string;
  eyebrow: string;
  title: string;
  description: string;
  children: ReactNode;
};

/** The shared frame of the landing sections, so any of them can go first without a redesign. */
export function HomeSection({ id, eyebrow, title, description, children }: HomeSectionProps) {
  const titleId = `${id}-title`;

  return (
    <Box component="section" id={id} aria-labelledby={titleId}>
      <Stack spacing={3}>
        <Stack spacing={1} sx={{ maxWidth: 720 }}>
          <Typography
            variant="overline"
            sx={{ color: 'primary.main', letterSpacing: '.12em', lineHeight: 1.5 }}
          >
            {eyebrow}
          </Typography>
          <Typography id={titleId} variant="h2">
            {title}
          </Typography>
          <Typography variant="body1" color="text.secondary">
            {description}
          </Typography>
        </Stack>
        {children}
      </Stack>
    </Box>
  );
}
